import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  static values = {
    timeout: { type: Number, default: 4000 },
    autoClose: { type: Boolean, default: true },
  }

  connect() {
    this.showNotifications()
    if (this.autoCloseValue) {
      this.startAutoClose()
    }
  }

  disconnect() {
    this.clearTimeouts()
  }

  showNotifications() {
    // Show all notifications with staggered animation
    this.contentTargets.forEach((target, index) => {
      setTimeout(() => {
        target.classList.remove('translate-x-full', 'opacity-0')
        target.classList.add('toast-slide-in')
      }, index * 100)
    })
  }

  close(event) {
    const notification = event.currentTarget.closest('[data-flash-target="content"]')
    this.removeNotification(notification)
  }

  removeNotification(notification) {
    if (!notification) return

    // Add slide-out animation
    notification.classList.add('toast-slide-out')

    // Remove after animation completes
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove()
      }
    }, 300)
  }

  startAutoClose() {
    this.contentTargets.forEach((target, index) => {
      const timeout = setTimeout(() => {
        this.removeNotification(target)
      }, this.timeoutValue + (index * 500)) // Stagger auto-close

      // Store timeout reference for cleanup
      target.dataset.timeoutId = timeout
    })
  }

  clearTimeouts() {
    this.contentTargets.forEach((target) => {
      const timeoutId = target.dataset.timeoutId
      if (timeoutId) {
        clearTimeout(parseInt(timeoutId))
      }
    })
  }

  // Pause auto-close on hover
  pauseAutoClose(event) {
    const notification = event.currentTarget
    const timeoutId = notification.dataset.timeoutId
    if (timeoutId) {
      clearTimeout(parseInt(timeoutId))
      notification.dataset.timeoutId = null
    }
  }

  // Resume auto-close when hover ends
  resumeAutoClose(event) {
    if (!this.autoCloseValue) return

    const notification = event.currentTarget
    const timeout = setTimeout(() => {
      this.removeNotification(notification)
    }, this.timeoutValue)

    notification.dataset.timeoutId = timeout
  }
}
